import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const NewLetterService = {
  // Define your API functions here

  create: async (data) => {
    const response = await apiService.post("/newsletteremails", data);
    return response.data;
  },
  update: async (data) => {
    const response = await apiService.put(
      `/newsletteremails/unsubscribe?email=${data}`
    );
    return response.data;
  },

  getList: async () => {
    // const params = new URLSearchParams({
    //   ...(search && { search }),
    //   ...(status && { status }),

    //   page: page.toString(),
    //   pageSize: pageSize.toString(),
    // });

    const response = await apiService.get(`/newsletteremails`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/newsletteremails/${id}`);
    return response.data;
  },
};

export default NewLetterService;
